<template>
  <div>
    <label>
      <span>使用するキャプチャボード</span>
      <select class="ms-1" v-model='deviceId'>
        <template v-for="d in devices">
          <option v-bind:key="d.deviceId" v-bind:value="d.deviceId">{{d.label}}</option>
        </template>
      </select>
    </label>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import VideoDevice from '@/components/resource/VideoDevice'

export default {
  props: {
    value: { type: String, },
    enabled: { type: Boolean, required: true, },
  },
  data() {
    return  {
      deviceId: '',
      devices: [],
    }
  },
  watch: {
    deviceId: function() {
      this.$emit('input', this.deviceId)
    },
  },
  async mounted() {
    if (this.enabled) {
      let state = await VideoDevice.queryPermissionAsync()
      if (state == 'granted') {
        this.open()
      }
    }
  },
  methods: {
    async open() {
      let state = await VideoDevice.queryPermissionAsync()
      if (state != 'granted') return

      this.devices = [
        {deviceId: '', label: ''},
        ...await VideoDevice.enumerateDevicesAsync()
      ]

      // 有効なデバイスが1つだけの場合は自動選択する。
      if (this.devices.length == 1) {
        this.$emit('input', this.devices[0].deviceId)
        return
      }

      // 最後に選択していたデバイスが見つかった場合は自動選択する。
      if (this.devices.some(d => d.deviceId == this.value)) {
        this.deviceId = this.value
        return
      }

      this.deviceId = ''
    },
    async close() {
      this.devices.splice(0, this.devices.length)
    },
  },
}
</script>

<style scoped>
</style>
